// String Utility Functions

export const camelCase = str => (str || '')
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((part, idx) => `${
        part.slice(0, 1)[`to${!idx ? 'Lower' : 'Upper'}Case`]()}${
        part.slice(1).toLowerCase()}`)
    .join('')

export const camelCaseToFlat = str => (str || '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()

export const createGUID = () => {
    const s4 = () => (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1)

    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`
}

export const slugify = (str, separator = '-') => str
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, separator)

export const getInitials = (str = '', maxLength = 2) => {
    const parts = str
        .split(/\s+/)
        .filter(_str => _str)

    return `${(parts[0] || '').substring(0, 1)}${
        (parts[parts.length - 1] || '').substring(0, 1)}`
        .trim()
        .toUpperCase()
        .substring(0, maxLength || 2)
}

export const getStringHash = (str) => {
    let hash = 0

    for (let i = 0; i < str.length; i++)
        hash = str.charCodeAt(i) + ((hash << 5) - hash)

    hash = Math.abs(hash)

    return hash
}

export const interpolate = (template, data, fallback) => {
    const _get = (path, obj, fb = `$\{${path}}`) => (path || '')
        .split('.')
        .reduce((acc, curr) => acc[curr] || fb, obj)

    return (template || '')
        .replace(/\$\{.+?}/g, (match) => {
            const path = match.substr(2, match.length - 3).trim()
            return _get(path, data || {}, fallback)
        })
}